<template>
  <div class="report" v-if="load">
    <limit-detail-menu v-model="date"></limit-detail-menu>
    <div class="main">
      <h2 class="main-title">Історія змін статусу</h2>
      <h2 class="main-title">{{ $route.params.number_cart}} — {{data.card.cardDescription}}</h2>
      <section class="limit">
        <header>
          <div class="col-td">ДАТА ЗМІНИ</div>
          <div class="col-td">Статус</div>
        </header>
          <div class="table-row" v-for="(tr, i) in data.data" :key="i">
            <div class="col-td desktop" style="width: 50%" >{{tr.period | formatOnlyDate }}</div>
            <div class="col-td desktop">{{tr.cardStatus}}</div>
          </div>
      </section>
    </div>
  </div>
</template>
<script>

import moment from "moment";
import LimitDetailMenu from "../components/LimitDetailMenu";
export default {
  name: 'HistoryLimitsStatus',
  components: {
      LimitDetailMenu

  },
  watch: {
    date: function (){
      this.load = false
      this.getData()
    },
  },
  data() {
    return {
      load: false,
      date: [new Date(moment().format('YYYY, MM, 01') ), new Date() ],
      data: [],
      cards: []
    }
  },
  created() {
    this.getData()
  },
  mounted () {

  },
  computed:{

  },
  methods: {

    getData: function (){


          this.axios.get('/userservice/v1/Card/'+this.$route.params.number_cart+'/status-change', {params: {startDate: moment(this.date[0]).format('YYYY-MM-DD') + ' 00:00:00', endDate: moment(this.date[1]).format('YYYY-MM-DD') + ' 23:59:59'}}).then(
            (resp) => {
              this.data = resp.data
            })
            .catch(error => {
              console.log('error_get_data');
              console.log(error);
              this.errored = true;
            })
            .finally(() => (
                this.load = true)
            )
    },
  }
}
</script>